var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowTurnUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M349.81 159.469C348.247 161.125 346.122 161.969 343.997 161.969C342.028 161.969 340.028 161.25 338.497 159.782L199.998 28.582V441.96C199.998 481.647 167.686 513.958 127.999 513.958H8C3.594 513.958 0 510.365 0 505.959S3.594 497.959 8 497.959H127.999C158.874 497.959 183.999 472.835 183.999 441.96V28.582L45.5 159.782C42.312 162.813 37.25 162.656 34.187 159.469C31.156 156.25 31.281 151.188 34.5 148.157L186.498 4.161C189.561 1.224 194.436 1.224 197.498 4.161L349.497 148.157C352.716 151.188 352.841 156.25 349.81 159.469Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowTurnUp);
export default __webpack_public_path__ + "static/media/arrow-turn-up.163d97d6f5dced3f9344af5160d71f5f.svg";
export { ForwardRef as ReactComponent };